import AboutUsComponent from '../components/about-us/aboutUs'

const AboutUs = () => <AboutUsComponent />

export default AboutUs;